/** Thai strings for the community features (English source text -> Thai): stickers, dares, fan mail, boss of the week. */
export const COMMUNITY: Record<string, string> = {
  // Stickers (reactions)
  'Cute!': 'น่ารัก!',
  'Scary!': 'น่ากลัว!',
  'So funny!': 'ตลกมาก!',
  'Cool!': 'เท่สุดๆ!',
  'Too tough!': 'เก่งเกินไป!',

  // Dare notes
  'Beat me if you can!': 'ชนะให้ได้สิ ถ้าแน่จริง!',
  'Bet this one is too easy for you.': 'ตัวนี้ง่ายไปสำหรับเธอมั้ง',
  'I drew something new. Try it!': 'วาดตัวใหม่มา ลองสู้ดูนะ!',
  'Meet my boss monster!': 'นี่คือบอสของฉันเอง!',
  'Good luck. You will need it!': 'โชคดีนะ ต้องใช้แน่ๆ!',

  // Battle result card
  'Telling {name} how it went…': 'กำลังบอก {name} ว่าสู้เป็นยังไง…',
  'Send {name} a sticker': 'ส่งสติกเกอร์ให้ {name}',
  'Send {name} a sticker:': 'ส่งสติกเกอร์ให้ {name}:',
  'Sticker sent to {name}!': 'ส่งสติกเกอร์ให้ {name} แล้ว!',
  'Could not send the sticker.': 'ส่งสติกเกอร์ไม่สำเร็จ',
  '-{n} HP to the boss! Everyone together: {done} / {pool}.': 'ตีบอสไป -{n} HP! ทุกคนรวมกันได้ {done} / {pool}',
  'The boss is down! Everyone who helped gets +{n} coins.': 'ล้มบอสได้แล้ว! ทุกคนที่ช่วยกันได้ +{n} เหรียญ',
  'This battle did not count for the boss: you used all your boss battles this week.': 'รอบนี้ไม่นับเป็นการตีบอส เพราะใช้สิทธิ์สู้บอสของสัปดาห์นี้ครบแล้ว',
  'A new boss week has started. Open the contest page to meet the new boss.': 'เริ่มสัปดาห์บอสใหม่แล้ว เปิดหน้าประกวดเพื่อดูบอสตัวใหม่',
  'The battle server did not answer, so this battle did not count for the boss.': 'เซิร์ฟเวอร์ไม่ตอบ รอบนี้เลยไม่นับเป็นการตีบอส',
  'Dare beaten! {name} will see it.': 'ชนะคำท้าแล้ว! {name} จะเห็นผลนี้',
  'The battle server did not answer, so {name} will not hear about this one.': 'เซิร์ฟเวอร์ไม่ตอบ {name} เลยจะไม่รู้ผลรอบนี้',

  // Memories
  'Everyone beat the boss: {monster}!': 'ทุกคนช่วยกันล้มบอส {monster} ได้แล้ว!',
  '{n} players knocked it down together. +{coins} coins for helping.': 'ผู้เล่น {n} คนช่วยกันล้มได้ ได้ +{coins} เหรียญที่มาช่วย',
  'Sent "{sticker}" to {name}': 'ส่ง "{sticker}" ให้ {name}',
  'For {monster}.': 'ให้ {monster}',
  'Dared {name} with {monster}': 'ส่ง {monster} ไปท้า {name}',
  'Passed the notebook across the classroom.': 'ส่งสมุดข้ามห้องไปให้เพื่อนแล้ว',

  // Live toasts
  '{name} dared you with {monster}! See Notebook → Friends.': '{name} ส่ง {monster} มาท้าเรา! ดูที่ สมุด → เพื่อน',
  '{name} beat your dare {monster}!': '{name} ชนะคำท้า {monster} ของเราแล้ว!',
  '{name} tried your dare {monster} and lost!': '{name} ลองสู้กับ {monster} ของเราแล้วแพ้!',
  '{name} sent a "{sticker}" sticker for {monster}!': '{name} ส่งสติกเกอร์ "{sticker}" ให้ {monster}!',

  // Friends → dares
  Dare: 'ส่งท้า',
  'Send {name} one of your monsters to beat': 'ส่งมอนสเตอร์ของเราไปท้า {name}',
  'That monster is not in your notebook yet. Try again in a moment.': 'มอนสเตอร์ตัวนี้ยังไม่อยู่ในสมุด ลองใหม่อีกสักครู่นะ',
  'Draw a monster first, then dare your friends with it!': 'วาดมอนสเตอร์ก่อน แล้วค่อยส่งไปท้าเพื่อนนะ!',
  'Monster to send': 'มอนสเตอร์ที่จะส่ง',
  Note: 'ข้อความ',
  '(no note)': '(ไม่มีข้อความ)',
  '{name} can fight it whenever they like. You will see every try and the sticker they send back.': '{name} มาสู้เมื่อไหร่ก็ได้ เราจะเห็นทุกครั้งที่เพื่อนลอง และสติกเกอร์ที่เพื่อนส่งกลับมา',
  Monster: 'มอนสเตอร์',
  'Dare {name}': 'ท้า {name}',
  'Send dare': 'ส่งคำท้า',
  'Dare sent to {name}!': 'ส่งคำท้าให้ {name} แล้ว!',
  'Take the dare back?': 'ยกเลิกคำท้าไหม?',
  'Remove {monster} from your sent dares?': 'ลบ {monster} ออกจากคำท้าที่ส่งไปไหม?',
  '{name} will not be able to fight {monster} any more.': '{name} จะสู้กับ {monster} ไม่ได้อีก',
  Remove: 'ลบ',
  'Put the dare away?': 'เก็บคำท้านี้ไหม?',
  '{monster} leaves your notebook. {name} still sees how you did.': '{monster} จะออกจากสมุดของเรา แต่ {name} ยังเห็นผลที่เราสู้ไว้',
  'Put away': 'เก็บ',
  'Dare from {name}': 'คำท้าจาก {name}',
  BEATEN: 'ชนะแล้ว',
  NEW: 'ใหม่',
  'You tried {n} time': 'ลองไปแล้ว {n} ครั้ง',
  'You tried {n} times': 'ลองไปแล้ว {n} ครั้ง',
  'beaten on try {n}': 'ชนะในครั้งที่ {n}',
  'beaten after {n} tries': 'ชนะหลังลอง {n} ครั้ง',
  'not beaten yet ({n} try)': 'ยังไม่ชนะ (ลอง {n} ครั้ง)',
  'not beaten yet ({n} tries)': 'ยังไม่ชนะ (ลอง {n} ครั้ง)',
  'waiting for {name}': 'รอ {name} มาสู้',
  'sticker: {sticker}': 'สติกเกอร์: {sticker}',
  'Take back': 'ยกเลิก',
  'Dares From Friends': 'คำท้าจากเพื่อน',
  'No dares yet. Dare a friend first, and maybe they will dare you back!': 'ยังไม่มีคำท้า ลองท้าเพื่อนก่อน เดี๋ยวเพื่อนอาจท้ากลับมา!',
  'Dares I Sent': 'คำท้าที่ฉันส่งไป',
  'Press "Dare" next to a friend to send them one of your monsters to beat.': 'กด "ส่งท้า" ข้างชื่อเพื่อน เพื่อส่งมอนสเตอร์ของเราไปให้เพื่อนสู้',

  // Monsters → fan mail
  'Fan Mail': 'จดหมายจากแฟนคลับ',
  'Opening the mailbox…': 'กำลังเปิดตู้จดหมาย…',
  'Sign in and share your monsters to get fan mail.': 'เข้าสู่เซิร์ฟเวอร์แล้วแชร์มอนสเตอร์ จะได้จดหมายจากแฟนคลับ',
  shared: 'แชร์',
  dare: 'คำท้า',
  '{n} fan': 'แฟน {n} คน',
  '{n} fans': 'แฟน {n} คน',
  '{n} battle': 'สู้ {n} ครั้ง',
  '{n} battles': 'สู้ {n} ครั้ง',
  'won {n}': 'ชนะ {n}',
  '{name} fought {monster} and sent "{sticker}"': '{name} สู้กับ {monster} แล้วส่ง "{sticker}" มา',
  '{name} beat {monster}': '{name} ชนะ {monster}',
  '{name} lost to {monster}': '{name} แพ้ {monster}',
  'Nobody has fought your monsters yet. Share one, dare a friend or win the contest!': 'ยังไม่มีใครสู้กับมอนสเตอร์ของเรา ลองแชร์ ส่งท้าเพื่อน หรือชนะการประกวดดูสิ!',
  'Latest fans': 'แฟนคลับล่าสุด',
  'Battle server offline — fan mail is unavailable.': 'เซิร์ฟเวอร์ปิดอยู่ ดูจดหมายจากแฟนคลับไม่ได้ตอนนี้',

  // Contest → boss of the week
  'Boss of the Week': 'บอสประจำสัปดาห์',
  'Sign in to help everyone beat the boss of the week.': 'เข้าสู่เซิร์ฟเวอร์ก่อน ถึงจะช่วยทุกคนตีบอสประจำสัปดาห์ได้',
  'Looking for the boss…': 'กำลังตามหาบอส…',
  'The first boss appears the week after the first contest champion is crowned.': 'บอสตัวแรกจะมาในสัปดาห์ถัดจากที่มีแชมป์ประกวดคนแรก',
  "Last week's champion is back, stronger! Everyone fights the same boss, and every battle chips away at its HP.": 'แชมป์สัปดาห์ที่แล้วกลับมาแล้ว แถมเก่งขึ้น! ทุกคนสู้กับบอสตัวเดียวกัน และทุกการต่อสู้จะช่วยลด HP ของมัน',
  'by {name} · champion of {round}': 'วาดโดย {name} · แชมป์รอบ {round}',
  BOSS: 'บอส',
  'Fight the boss!': 'สู้กับบอส!',
  'You used all your boss battles this week': 'ใช้สิทธิ์สู้บอสของสัปดาห์นี้ครบแล้ว',
  'Everyone beat the boss!': 'ทุกคนช่วยกันล้มบอสได้แล้ว!',
  'Boss HP left: {left} / {pool}': 'HP บอสเหลือ {left} / {pool}',
  'Boss HP': 'HP บอส',
  '{n} player has helped so far.': 'มีผู้เล่นช่วยแล้ว {n} คน',
  '{n} players have helped so far.': 'มีผู้เล่นช่วยแล้ว {n} คน',
  'My hits: {hits} ({damage} damage) · battles left this week: {left}': 'ฉันตีไป {hits} ครั้ง ({damage} ดาเมจ) · สัปดาห์นี้สู้ได้อีก {left} ครั้ง',
  'This is your drawing! Every battle sends you fan mail.': 'นี่คือรูปที่เราวาด! ทุกครั้งที่มีคนสู้ เราจะได้จดหมายจากแฟนคลับ',
  'New boss {when}.': 'บอสตัวใหม่มา{when}',
  'Battle server offline — the boss is unavailable.': 'เซิร์ฟเวอร์ปิดอยู่ ตอนนี้สู้บอสไม่ได้',

  // Server messages (shown as they come, first letter capitalised)
  'Fight this monster before sending its artist a sticker.': 'ต้องสู้กับมอนสเตอร์ตัวนี้ก่อน ถึงจะส่งสติกเกอร์ให้คนวาดได้',
  'You can only dare your friends.': 'ส่งท้าได้เฉพาะเพื่อนเท่านั้น',
  'That friend already has 3 of your dares to beat.': 'เพื่อนคนนี้มีคำท้าจากเราที่ยังไม่ชนะอยู่ 3 อันแล้ว',
  'You have too many dares sent; remove some old ones first.': 'ส่งคำท้าไว้เยอะเกินไป ลบอันเก่าออกก่อนนะ',
  'No such dare.': 'ไม่พบคำท้านี้',
  'That dare was sent to someone else.': 'คำท้านี้ส่งให้คนอื่น',
  'Fight the dare before sending a sticker.': 'สู้กับคำท้าก่อน ถึงจะส่งสติกเกอร์ได้',
  'You cannot dare yourself.': 'ท้าตัวเองไม่ได้นะ',
  'Unknown note.': 'ไม่รู้จักข้อความนี้',
  'There is no boss this week yet.': 'สัปดาห์นี้ยังไม่มีบอส',
  'That boss week is over.': 'สัปดาห์บอสนั้นจบไปแล้ว',
  'You have used all your boss battles this week.': 'ใช้สิทธิ์สู้บอสของสัปดาห์นี้ครบแล้ว',
  'No such monster.': 'ไม่พบมอนสเตอร์ตัวนี้',
  'Unknown sticker.': 'ไม่รู้จักสติกเกอร์นี้',
};
